var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Card from "../../atoms/card/card";
import { fetchPendingInvites, revokeInvite, resendInvite, } from "../../../redux/actions/invite_user";
var getRoleLabel = function (role) {
    if (!role)
        return "User";
    return role.charAt(0).toUpperCase() + role.slice(1);
};
var getRoleStyle = function (role) {
    switch (role) {
        case "admin":
        case "adviser":
            return "bg-purple-100 text-purple-800";
        case "member":
        case "jobseeker":
            return "bg-blue-100 text-blue-800";
        case "manager":
            return "bg-amber-100 text-amber-800";
        case "organisation":
            return "bg-green-100 text-green-800";
        default:
            return "bg-gray-100 text-gray-800";
    }
};
/**
 * Pending Invites card: lists not-yet-registered invitations with
 * Resend/Revoke actions, shared between the Accounts page (org/superorg team
 * member invites) and the Manage Users page (jobseeker/adviser/manager/
 * organisation invites created via "Create User").
 */
export default function PendingInvites(props) {
    var _a;
    var orgId = props.orgId, userType = props.userType, refreshSignal = props.refreshSignal;
    var enabled = (_a = props.enabled) !== null && _a !== void 0 ? _a : true;
    var dispatch = useDispatch();
    var pendingInvites = useSelector(function (state) { var _a; return (_a = state.rootReducer.InviteUserReducer.pendingInvites) !== null && _a !== void 0 ? _a : []; });
    var pendingInvitesStatus = useSelector(function (state) { return state.rootReducer.InviteUserReducer.pendingInvitesStatus; });
    var _b = useState(null), notification = _b[0], setNotification = _b[1];
    var _c = useState(""), lastActionEmail = _c[0], setLastActionEmail = _c[1];
    useEffect(function () {
        if (enabled) {
            dispatch(fetchPendingInvites(orgId, userType));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [enabled, orgId, userType, refreshSignal, dispatch]);
    useEffect(function () {
        if (pendingInvitesStatus === "success" && lastActionEmail) {
            setNotification({ message: "Invitation resent to ".concat(lastActionEmail), type: "success" });
            setLastActionEmail("");
            var timer_1 = setTimeout(function () { return setNotification(null); }, 4000);
            return function () { return clearTimeout(timer_1); };
        }
        if (pendingInvitesStatus === "error") {
            setNotification({ message: "Failed to resend invitation. Please try again.", type: "error" });
            var timer_2 = setTimeout(function () { return setNotification(null); }, 4000);
            return function () { return clearTimeout(timer_2); };
        }
    }, [pendingInvitesStatus, lastActionEmail]);
    return (_jsxs(Card, __assign({ multiLine: true, className: "!pt-4 mt-6" }, { children: [_jsx("h2", __assign({ className: "text-xl font-semibold mb-6" }, { children: "Pending Invites" })), notification && (_jsx("div", __assign({ className: "mb-4 px-4 py-3 rounded-lg text-sm font-medium ".concat(notification.type === "success"
                    ? "bg-green-100 text-green-800 border border-green-200"
                    : "bg-red-100 text-red-800 border border-red-200") }, { children: notification.message }))), pendingInvites.length === 0 ? (_jsx("div", __assign({ className: "py-8 text-center text-gray-500" }, { children: _jsx("p", { children: "No pending invites." }) }))) : (_jsx("div", __assign({ className: "overflow-x-auto" }, { children: _jsxs("table", __assign({ className: "w-full text-left" }, { children: [_jsx("thead", { children: _jsxs("tr", __assign({ className: "border-b border-gray-200" }, { children: [_jsx("th", __assign({ className: "pb-3 font-semibold text-gray-700" }, { children: "Email" })), _jsx("th", __assign({ className: "pb-3 font-semibold text-gray-700" }, { children: "Role" })), _jsx("th", __assign({ className: "pb-3 font-semibold text-gray-700" }, { children: "Actions" }))] })) }), _jsx("tbody", { children: pendingInvites.map(function (invite, index) { return (_jsxs("tr", __assign({ className: "border-b border-gray-100 hover:bg-gray-50" }, { children: [_jsx("td", __assign({ className: "py-3" }, { children: invite.email })), _jsx("td", __assign({ className: "py-3" }, { children: _jsx("span", __assign({ className: "px-3 py-1 rounded-full text-sm ".concat(getRoleStyle(invite.target_role)) }, { children: getRoleLabel(invite.target_role) })) })), _jsx("td", __assign({ className: "py-3" }, { children: _jsxs("div", __assign({ className: "flex items-center gap-3" }, { children: [_jsx("button", __assign({ onClick: function () {
                                                        setLastActionEmail(invite.email);
                                                        dispatch(resendInvite(invite.token, invite.email));
                                                    }, className: "text-blue-600 hover:text-blue-800 text-sm font-medium" }, { children: "Resend" })), _jsx("button", __assign({ onClick: function () { return dispatch(revokeInvite(invite.token)); }, className: "text-red-600 hover:text-red-800 text-sm font-medium" }, { children: "Revoke" }))] })) }))] }), index)); }) })] })) })))] })));
}
